export default __webpack_public_path__ + "static/media/business.0f1ef559.svg";